import { Button, Chip, Stack } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { filterVendors } from 'store/thunks/vendorManagementThunk';

const VendorManagementFilterStatusBar = () => {
  const dispatch = useDispatch();
  const filter = useSelector(({ inventory }) => inventory.vendorManagement.filter);

  const removeFilter = (key) => () =>
    dispatch(filterVendors({ filter: { ...filter, [key]: undefined } }));

  const removeAll = () => dispatch(filterVendors({ filter: { vendor: undefined } }));

  return (
    <Stack direction='row' spacing={0.75} flexWrap='wrap' alignItems='center'>
      {filter.vendor && (
        <Chip
          size='small'
          label={`Vendor = ${filter.vendor}`}
          variant='contained'
          onDelete={removeFilter('vendor')}
        />
      )}
      {filter.vendor && (
        <Button size='small' onClick={removeAll} sx={{ fontSize: 12 }}>
          Remove All
        </Button>
      )}
    </Stack>
  );
};

export default VendorManagementFilterStatusBar;
